var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _circle3, _rect, _rect2, _rect3, _circle4, _circle5, _circle6, _circle7, _rect4, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 125,
    viewBox: "0 0 211 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 83V95.2464C131 98.0078 133.239 100.246 136 100.246H195C197.761 100.246 200 102.485 200 105.246V117",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50V62.2464C1 65.0078 3.23858 67.2464 6 67.2464H70",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 100,
    r: 3,
    fill: "#5A4BF8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 67,
    r: 3,
    fill: "#5A4BF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88H49.5C46.7386 88 44.5 90.2386 44.5 93V104.5C44.5 107.261 42.2614 109.5 39.5 109.5H36C33.2386 109.5 31 111.739 31 114.5V123.5",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14H47C49.7614 14 52 16.2386 52 19V35C52 37.7614 54.2386 40 57 40H79.5",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 28.5L148 28.5C150.761 28.5 153 26.2614 153 23.5L153 -1.09278e-06",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149 57.5H162.5C165.261 57.5 167.5 59.7386 167.5 62.5V69.5C167.5 72.2614 169.739 74.5 172.5 74.5H185C187.761 74.5 190 72.2614 190 69.5V50C190 47.2386 192.239 45 195 45H211",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 61,
    r: 3,
    fill: "#5A4BF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106.854,
    y: 18.5858,
    width: 67,
    height: 68,
    rx: 9,
    transform: "rotate(45 106.854 18.5858)",
    fill: "white",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.854,
    y: 12.5858,
    width: 67,
    height: 68,
    rx: 9,
    transform: "rotate(45 106.854 12.5858)",
    fill: "white",
    stroke: "#ADABFF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106.854,
    y: 6.27036,
    width: 67,
    height: 68,
    rx: 9,
    transform: "rotate(45 106.854 6.27036)",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 25.5,
    r: 3,
    fill: "#5A4BF8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 100,
    r: 3,
    fill: "#5A4BF8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 11.5,
    r: 3,
    transform: "rotate(-90 152.5 11.5)",
    fill: "#5A4BF8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 54,
    r: 21,
    fill: "#5A4BF8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 43,
    width: 5.5,
    height: 13.5,
    rx: 1,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 62.75,
    r: 3.25,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.325de953aa73f5ee59b0d385b1ba6947.svg";
export { ForwardRef as ReactComponent };